import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Divider, Input, Modal, Radio, Space } from "antd";

import { Header, Nav, HamburgerMenu, BaseTable } from "./components";

import {
  loginUserCheck,
  logoutUser,
  productFetchByInventory,
  productUpdateInventory,
} from "../redux/actions";

class AdminProductInventory extends Component {
  constructor() {
    super();
    this.state = {
      selectType: "wall",
      toggleMenu: false,
      isModalOpen: false,
      isLoading: true,
      modalData: {},
      inventory: "",
      columns: [],
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    const params = this.getParams();
    this.setState({
      selectType: params.type,
    });
  }

  componentDidMount() {
    this._handleSelectType(this.state.selectType)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.products) {
      let brands = []
      nextProps.products.forEach(item => {
        brands.push(item.brand_title)
      });
      brands = [...new Set(brands.map(item => item))];
      brands.sort((a, b) => a.localeCompare(b))

      const columns = [
        {
          title: "Brand",
          dataIndex: "brand_title",
          filters: brands.map(item => ({
            text: item,
            value: item
          })),
          onFilter: (value, record) => record.brand_title.indexOf(value) === 0,
        },
        {
          title: "Image",
          dataIndex: "img",
          key: "img",
          render: (text) => (
            <img
              src={text}
              style={{ height: "30px", maxWidth: "100px" }}
              alt="product"
            />
          ),
        },
        {
          title: "Model",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "Price (1)",
          dataIndex: "price",
          key: "price",
        },
        // {
        //   title: "BTU",
        //   dataIndex: "btu",
        //   key: "btu",
        // },
        {
          title: "Created Date",
          dataIndex: "prod_id",
          key: "prod_id",
          render: (text) => {
            const d = new Date(Number(text));
            const date =
              d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            return date;
          },
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle" className="table-action">
              <Button
                type="primary"
                className="btn-edit"
                style={{  }}
                onClick={() => {
                  this.setState({
                    isModalOpen: true,
                    modalData: record,
                    inventory: record.inventory,
                  });
                }}
              >
                จำนวน
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                className="btn-edit"
                onClick={() =>
                  (window.location = `/admin/editproduct?id=${record.id}`)
                }
              >
                แก้ไข
              </Button>
              {/* <Divider type="vertical" />
              <Button
                type="primary"
                danger
                onClick={() =>
                  this._onDeleteItem(record.id, record.img, record.type)
                }
              >
                ลบ
              </Button> */}
            </Space>
          ),
        },
      ]
      this.setState({ columns, isLoading: false })
    }
  }

  getParams() {
    const searchParams = new URLSearchParams(this.props.location.search);
    return {
      type: searchParams.get("type") || "wall",
    };
  }

  _handleSelectType(type) {
    this.props.productFetchByInventory(type);
    this.setState({ selectType: type });
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  _onSubmitInventory() {
    const data = {
      inventory: this.state.inventory,
    };
    this.props.productUpdateInventory(this.state.modalData.id, data, this.state.selectType);
    this.setState({ isModalOpen: false });
  }

  // _onDeleteItem(id, img, type) {
  //   if (window.confirm("Are you sure you want to delete this item?")) {
  //     let file = decodeURIComponent(img.substring(70, 97));
  //     const data = {
  //       brand_id: this.state.brand_id,
  //       brand_title: this.state.brand_title,
  //       type: "type_" + type,
  //       type2: type,
  //     };
  //     this.props.productDeleteById(id, file, data);
  //   }
  // }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-productdetail">
          <Nav active="productInventory" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>
                  สินค้าหมด
                  {/* <span className="brandname">{this.state.brand_title}</span> */}
                </h2>

                <Radio.Group
                  disabled={this.state.isLoading}
                  defaultValue={this.state.selectType}
                  buttonStyle="solid"
                  onChange={(event) =>
                    this._handleSelectType(event.target.value)
                  }
                >
                  <Radio.Button value="wall">แอร์ผนัง</Radio.Button>
                  <Radio.Button value="hang">แอร์แขวน</Radio.Button>
                  <Radio.Button value="four">แอร์สี่ทิศทาง</Radio.Button>
                  <Radio.Button value="concealed">แอรเ์ปลือย</Radio.Button>
                  <Radio.Button value="stand">แอร์ตู้ตั้ง</Radio.Button>
                  <Radio.Button value="one_way">หนึ่งทิศทาง</Radio.Button>
                </Radio.Group>

                <div className="btn-addproduct">
                  {/* <Link
                    to={{
                      pathname: "/admin/addproduct",
                      search: `?id=${this.state.brand_id}&title=${this.state.brand_title}&type=${this.state.selectType}`,
                    }}
                    className="add-product"
                  >
                    เพิ่มสินค้า
                  </Link> */}
                </div>
              </div>
              <div className="info">
                <BaseTable
                  columns={this.state.columns}
                  datas={this.props.products ? this.props.products : []}
                  loading={this.state.isLoading}
                />
              </div>
              <Modal
                title="แก้ไขจำนวนคงเหลือ"
                cancelText="ยกเลิก"
                okText="บันทึก"
                open={this.state.isModalOpen}
                onOk={() => this._onSubmitInventory()}
                onCancel={() => this.setState({ isModalOpen: false })}
              >
                <h3>{`${this.state.modalData.brand_title} - ${this.state.modalData.title}`}</h3>
                <div
                  className="price"
                  style={{
                    display: "flex",
                    margin: "20px 0",
                    marginRight: "20px",
                  }}
                >
                  <p style={{ width: "130px", margin: "auto" }}>
                    จำนวนคงเหลือ:
                  </p>
                  <Input
                    name="inventory"
                    value={this.state.inventory}
                    onChange={(event) => this._onHandleChange(event)}
                  />
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, product }) => {
  return {
    user: auth.user,
    products: product.products,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  productFetchByInventory,
  productUpdateInventory,
})(AdminProductInventory);
